import request from "api/request";

export function depthLearnList(data){
  return request({
    url : "/creation/deptlearnList",
    method : "post",
    data
  });
}